import * as React from 'react';
import { useSelector } from 'react-redux';
import { HCard } from '../../components/CompanySeoCard';
import { getFirstAvailablePhone, getFullUrl, getName } from '../../selectors/newbuilding';
import { getSchemaOrgAddress } from '../../selectors/newbuilding/getSchemaOrgAddress';

export const CompanySeoCard = () => {
  const newbuildingName = useSelector(getName);
  const url = useSelector(getFullUrl);
  const phone = useSelector(getFirstAvailablePhone);
  const { streetAddress, addressLocality, addressRegion } = useSelector(getSchemaOrgAddress);

  return (
    <HCard
      url={url}
      locality={`${addressRegion}, ${addressLocality}`}
      address={streetAddress}
      phone={phone}
      newbuildingName={newbuildingName}
    />
  );
};
